if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined, showAssociatedOnly) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        purchaseOptions: [],
        selectedPurchaseOption: '',
        init() {
          if (showAssociatedOnly) {
            document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
              this.renderMedia();
            }, { once: true });
          }
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            this.$nextTick(() => this.syncPurchaseOption());
          });
          window.addEventListener('mondaymuse:purchase-option-price', (event) => {
            if (event.detail?.sectionId !== sectionId) return;
            this.$nextTick(() => this.syncPurchaseOption(event.detail));
          });
          this.$nextTick(() => setTimeout(() => this.syncPurchaseOption(), 0));
        },
        renderProductPrice(html) {
          const destinations = Array.from(document.getElementsByClassName(`price-sticky-${sectionId}`));
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          if (showAssociatedOnly) {
            this.$nextTick(() => {
              const destination = document.getElementById('product-image-sticky-' + sectionId)?.querySelector('img');
              const source = document.querySelector('.product-media-container')?.querySelector('.media_active img')?.getAttribute('src');

              if (source && destination) destination.setAttribute('src', source);
            })
          } else {
            const destination = document.getElementById('product-image-sticky-' + sectionId);
            const source = html.getElementById('product-image-sticky-' + sectionId);
    
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        },
        purchaseOptionLabel(input) {
          const card = input.closest('label');
          const title = input.dataset.stickyLabel || card?.querySelector('.product-purchase-options__title')?.textContent?.trim() || input.value;
          const price = input.dataset.price?.trim();
          return price ? `${title} · ${price}` : title;
        },
        syncPurchaseOption(detail = {}) {
          const root = document.getElementById(`subscription-${sectionId}`);
          const stickyForm = document.getElementById(`product-form-sticky-${sectionId}`);
          if (!stickyForm) return;

          stickyForm.querySelectorAll('[data-sticky-purchase-option]').forEach((input) => input.remove());
          if (!root) {
            this.purchaseOptions = [];
            this.selectedPurchaseOption = '';
            return;
          }

          const optionInputs = Array.from(root.querySelectorAll('input[name^="purchase-option-"]'));
          this.purchaseOptions = optionInputs.map((input) => ({
            value: input.value,
            label: this.purchaseOptionLabel(input)
          }));

          const selectedInput = optionInputs.find((input) => input.checked);
          this.selectedPurchaseOption = detail.option || selectedInput?.value || '';

          const mainVariant = document.getElementById(`update-variant-${sectionId}`);
          const stickyVariant = document.getElementById(`update-variant-sticky-${sectionId}`);
          if (stickyVariant && (detail.variantId || mainVariant?.value)) stickyVariant.value = detail.variantId || mainVariant.value;

          root.querySelectorAll('input[name="selling_plan"], input[name^="properties[_monday_subscription_"]').forEach((source) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = source.name;
            input.value = source.name === 'selling_plan' && detail.sellingPlanId !== undefined ? detail.sellingPlanId : source.value;
            input.dataset.stickyPurchaseOption = '';
            stickyForm.appendChild(input);
          });
        },
        changePurchaseOptionSticky(event) {
          this.selectedPurchaseOption = event.target.value;
          window.dispatchEvent(new CustomEvent('mondaymuse:select-purchase-option', {
            detail: {
              sectionId,
              option: this.selectedPurchaseOption
            }
          }));
          setTimeout(() => this.syncPurchaseOption(), 0);
        }
      }))
    })
  })
}
